import { checkLocaleData } from 'src/utils';

interface LocaleInfo {
  url?: string | null;
  translatedFrom?: string | null;
}

export enum LocaleInfoTypes {
  URL = 'url',
  TRANSLATED_FROM = 'translatedFrom',
}
interface Subdomains {
  [locale: string]: LocaleInfo;
}

const isProd =
  process.env.NEXT_PUBLIC_ENVIRONMENT_NAME?.toLowerCase() === 'grn';

// Sorted according to the order of the locales in the language selector (header)
const subdomains: Subdomains = {
  'zh-CN': {
    url: isProd
      ? 'https://zh.virginatlantic.com/cn/zh'
      : 'https://stg-zh.virginatlantic.com/cn/zh',
  },

  'ar-AE': {
    url: isProd
      ? 'https://ar.virginatlantic.com/ae/ar'
      : 'https://stg-ar.virginatlantic.com/ae/ar',
  },
  'es-US': {
    url: isProd
      ? 'https://es.virginatlantic.com/us/es'
      : 'https://stg-es.virginatlantic.com/us/es',
  },
  'ko-KR': {
    translatedFrom: 'en-KR',
  },
};

export function getLocales(): string[] {
  return Object.keys(subdomains);
}

export function getLocaleInfo(
  localeIdentifier: string,
  infoType: LocaleInfoTypes
): string | null {
  const locale = checkLocaleData(localeIdentifier);
  if (!locale) {
    return null;
  }

  const subdomain = subdomains[locale];

  if (!subdomain) {
    return null;
  }

  const localeInfo = subdomain[infoType];
  return localeInfo || null;
}

export default getLocaleInfo;